// extracted by mini-css-extract-plugin
module.exports = {"hide":"UploadImageBox_hide__Xf0g5","imgPlaceholder":"UploadImageBox_imgPlaceholder__1DrUq","icon":"UploadImageBox_icon__10C45"};